import { NgModule } from '@angular/core';

import { NgxInactivityDirective } from './ngx-inactivity.directive';

@NgModule({
  declarations: [
    NgxInactivityDirective
  ],
  exports: [
    NgxInactivityDirective
  ]
})
export class NgxInactivity {
}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/node_modules/ngx-inactivity/src/app/ngx-inactivity/ngx-inactivity.module.ts